/* Stockists hover behaviour.

   Two things css cannot do on its own:

   - Centring the hovered card in the viewport, which needs a scroll.
   - Showing the photos belonging to the address under the cursor. The CMS will
     emit an arbitrary list of addresses per country, so matching a hovered
     entry's slug to a photo set's slug has to be done in script rather than by
     writing a selector pair per address.

   The blur on the addresses you are not pointing at is pure css, in
   stockists.css, alongside the rest of the reveal. */
(function () {
  'use strict';

  var main = document.querySelector('.stockists-main');
  var grid = main && main.querySelector('.stockists-grid');
  if (!grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('.stockist-card'));
  if (!cards.length) return;

  var wide = window.matchMedia('(min-width: 992px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* --------------------------------------------------------------------
     Photos follow the address under the cursor.
     -------------------------------------------------------------------- */
  function setsFor(card) {
    /* The block sits inside the card now, so it is measured against the card
       rather than the whole scroll. */
    return card.querySelectorAll('.stockist-photo-set');
  }

  function showAddress(card, slug) {
    Array.prototype.forEach.call(setsFor(card), function (set) {
      set.classList.toggle('is-active', slug != null && set.dataset.entry === slug);
    });
  }

  /* --------------------------------------------------------------------
     Centring the hovered card.

     Two guards, both about the same failure: the scroll moves the card out
     from under a cursor that has not moved, which fires pointerleave, which
     lets pointerenter fire again the moment it settles - a card that jitters
     between two positions forever.

     DEADZONE means a card already near the middle is left alone, so the
     settled state is stable. COOLDOWN means a card cannot be re-centred
     immediately after it was, which breaks the loop even if the pointer does
     leave and return.
     -------------------------------------------------------------------- */
  var DEADZONE = 48;
  var COOLDOWN = 900;
  var lastCentred = new WeakMap();

  function centre(card) {
    if (!wide.matches || still.matches) return;

    var now = (window.performance && performance.now) ? performance.now() : Date.now();
    var prev = lastCentred.get(card);
    if (prev != null && now - prev < COOLDOWN) return;

    var box = card.getBoundingClientRect();
    var off = (box.top + box.height / 2) - window.innerHeight / 2;
    if (Math.abs(off) < DEADZONE) return;

    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var to = Math.min(max, Math.max(0, window.scrollY + off));

    lastCentred.set(card, now);
    if (window.lenis && typeof window.lenis.scrollTo === 'function') {
      window.lenis.scrollTo(to, { duration: 0.8 });
    } else {
      window.scrollTo({ top: to, behavior: 'smooth' });
    }
  }

  cards.forEach(function (card) {
    card.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      centre(card);
    });

    card.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      showAddress(card, null);
    });

    card.querySelectorAll('.stockist-entry').forEach(function (entry) {
      entry.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        showAddress(card, entry.dataset.entry);
      });

      /* Keyboard: the link inside is the only focusable thing in an entry. */
      entry.addEventListener('focusin', function () {
        showAddress(card, entry.dataset.entry);
      });
    });

    card.addEventListener('focusout', function (e) {
      if (!card.contains(e.relatedTarget)) showAddress(card, null);
    });
  });

  /* --------------------------------------------------------------------
     Scrolling lets go of the card.

     :hover stays latched to a cursor that has not moved, so scrolling away
     from a card leaves it held open behind you - the other cards stay faded
     and its photos stay up. css has no way to release that, so the grid
     carries .is-hover-suspended and every hover rule is gated on its absence.

     Keyed off scroll INPUT - wheel, touch drag, the scrolling keys - rather
     than the scroll event, because the centring scroll this file performs
     fires scroll events too, and a card would cancel its own hover the
     instant it centred itself.
     -------------------------------------------------------------------- */
  var KEYS = {
    ArrowUp: 1, ArrowDown: 1, PageUp: 1, PageDown: 1, Home: 1, End: 1, ' ': 1,
  };

  function suspend() {
    if (!grid.classList.contains('is-hover-suspended')) {
      grid.classList.add('is-hover-suspended');
      cards.forEach(function (c) { showAddress(c, null); });
    }
  }

  window.addEventListener('wheel', suspend, { passive: true });
  window.addEventListener('touchmove', suspend, { passive: true });
  window.addEventListener('keydown', function (e) {
    if (KEYS[e.key]) suspend();
  });

  /* Released only by the pointer genuinely moving. Scrolling under a still
     cursor also emits pointermove, because the element beneath it changes, so
     the coordinates have to be compared rather than trusted. */
  var atX = null;
  var atY = null;
  window.addEventListener('pointermove', function (e) {
    /* The position is recorded on every move, including the first, so there is
       always something to compare against. Releasing on a move that has no
       baseline would hand the hover straight back on the synthetic event the
       scroll itself emits. */
    var moved = atX !== null && (e.clientX !== atX || e.clientY !== atY);
    atX = e.clientX;
    atY = e.clientY;
    if (moved) grid.classList.remove('is-hover-suspended');
  }, { passive: true });

  /* Dropping below the desktop breakpoint hides the photos entirely, so clear
     any set left active by a resize rather than leaving it to reappear. */
  var onChange = function () {
    if (!wide.matches) cards.forEach(function (c) { showAddress(c, null); });
  };
  if (wide.addEventListener) wide.addEventListener('change', onChange);
  else if (wide.addListener) wide.addListener(onChange);
})();
